import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const DateContainer = styled.div`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  flex-grow: 0;
  margin: 8px 4px;

  ${media.xl`
    margin: 10px 10px;
  `}
`;

export const SpaDetailsContainer = styled.div`
  ${media.xl`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`}
`;

export const GuestsContainer = styled.div`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  flex-grow: 0;
  margin: 10px 16px 0 4px;
  ${media.xl`
    margin: 10px 16px 0 10px;
  `}
`;
